// extracted by mini-css-extract-plugin
module.exports = {"root":"error_root__2kZ4-","title":"error_title__3GTHp","btn":"error_btn__1lCda"};